export default __webpack_public_path__ + "static/media/about-us-img-01.20e2f0e3.jpg";